import Cookies from 'js-cookie';
import type { WebLocale } from '@/enums/web-locale';

const SUBDIVISION = 'subdivision';
const COUNTRY_CODE_LENGTH = 2;

export type CountryCode = Uppercase<WebLocale>;

/**
 * We are getting the Country and the Subdivision code by using the ISO 3166-2
 * Codes for the representation of names of countries and their subdivisions
 * https://www.wikidata.org/wiki/Property:P300
 *
 * The code uses the structure:
 * The first part is the ISO 3166-1 alpha-2 code of the country
 * The second part is a string of up to three alphanumeric characters
 *
 * Examples:
 *
 * Code   Country         Region
 * USCA   United States   California
 * USTX   United States   Texas
 * GBENG  United Kingdom  England
 * IT62   Italy           Lazio
 * ESMD   Mexico          Madrid
 * DK84   Denmark         Hovedstaden
 * AUNSW  Australia       New South Wales (NSW)
 * NZAUK  New Zeland      Auckland
 * VNSG   Vietnam         Ho Chi Minh City
 */
export const USER_GEO_LOCATION = Cookies.get(SUBDIVISION) as CountryCode;

/** Get the coungry code by returning the first two characters. */
export const USER_GEO_LOCATION_COUNTRY_CODE = USER_GEO_LOCATION?.slice(0, COUNTRY_CODE_LENGTH) as CountryCode;

/** Get the region (subdivision) code by returning the remaining digits. */
export const USER_GEO_LOCATION_REGION = USER_GEO_LOCATION?.substring(COUNTRY_CODE_LENGTH);
